// Copyright (c) Microsoft. All rights reserved.

import { Image } from '@fluentui/react-components';
import React from 'react';
import { ChatMessage } from '../../../libs/models/conversations/ChatMessage';
import InfiniteScroll from 'react-infinite-scroller';
import loading from '../../../assets/etc-icons/icon_loading_small.gif';
import { ChatHistoryItems } from './ChatHistoryItems';

interface ChatHistoryProps {
  messages: ChatMessage[];
  hasMore: boolean;
  onLoadMore: () => void;
  isLoading: boolean;
  botStatus: boolean;
  scrollViewTargetRef: React.RefObject<HTMLDivElement>;
}

export const ChatHistory: React.FC<ChatHistoryProps> = ({
  messages,
  hasMore,
  onLoadMore,
  isLoading,
  botStatus,
  scrollViewTargetRef,
}) => {
  const loadMore = () => {
    if (!isLoading) {
      onLoadMore();
    }
  };

  return (
    <section className="chat-history">
      <InfiniteScroll
        initialLoad={true}
        loadMore={() => {
          loadMore();
        }}
        hasMore={hasMore}
        isReverse={true}
        useWindow={false}
        loader={<Image src={loading} key={0} style={{ margin: 'auto' }} />}
        style={{ display: 'flex', flexDirection: 'column' }}
        getScrollParent={() => scrollViewTargetRef.current}
      >
        <h2 className="blind">대화</h2>
        <div className="chat-history-item">
          {messages.map((item, index) => (
            <ChatHistoryItems
              key={item.id}
              messageIndex={index}
              item={item}
              isLast={messages.length - 1 === index}
              botStatus={botStatus}
            />
          ))}
        </div>
      </InfiniteScroll>
    </section>
  );
};
